import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  width: ${({ small }) => (small ? '14px' : '18px')};
  height: ${({ small }) => (small ? '14px' : '18px')};
  position: relative;
  background-color: ${({ light, theme }) => (light ? theme.colors.background.light : theme.colors.background.grey)};
  border: none;
  border-radius: 50%;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 0px 0px 13px 1px rgba(0, 0, 0, 0.05);

  &:before {
    content: '';
    display: ${({ collapsible, collapsed }) => (collapsible && !collapsed ? 'none' : 'inline-block')};
    width: 2px;
    height: ${({ small }) => (small ? '8px' : '10px')};
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    background-color: ${({ theme }) => theme.colors.primary.dark};
  }

  &:after {
    content: '';
    display: inline-block;
    width: ${({ small }) => (small ? '8px' : '10px')};
    height: 2px;
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    background-color: ${({ theme }) => theme.colors.primary.dark};
  }

  &:hover {
    box-shadow: 0px 0px 13px 1px rgba(0, 0, 0, 0.1);
  }
`;
